import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  withStyles,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";

import { callApi } from "../../actions/base";
import { navigate } from "gatsby";

const styles = theme => ({
  loader: {
    color: "#1e5abb",
  },
  textField: { margin: theme.spacing(1) },
  dialog: {
    minWidth: "800px",
  },
});

const orderTypeOptions = [
  {
    value: "individual",
    label: "Osoba fizyczna",
  },
  {
    value: "sole_proprietorship",
    label: "Jednoosobowa działalność gospodarcza",
  },
  {
    value: "company",
    label: "Spółka lub fundacja",
  },
];

const INITIAL_STATE = {
  type: "",
  description: "",
}

const OrderCreate = ({ classes }) => {
  const [open, setOpen] = useState(false);
  const [order, setOrder] = useState(null);
  const [form, setForm] = useState(INITIAL_STATE);

  const [loading, setLoading] = useState(false);

  const [generalError, setGeneralError] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    type: false,
    description: false,
  });

  const [inputErrors, setInputErrors] = useState({
    typeError: "",
    descriptionError: "",
  });

  const onSuccess = data => {
    setOrder(data);
    setLoading(false);
    navigate(`/dashboard/orders/${data.code}`);
  };

  const onError = data => {
    if (data.errors) {
      setValidationErrors(data.errors);
    }
    if (data.error) {
      setGeneralError(data.error);
    }
    setLoading(false);
  };

  const handleClickOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false)
    setForm(INITIAL_STATE);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    callApi("/auth/orders", form, onSuccess, onError);
  };

  const handleInputChange = e => {
    setValidationErrors({ ...validationErrors, [e.target.name]: false });
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const canBeSubmitted = () => Object.values(form).every(val => !!val);

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        Utwórz nowe zlecenie
      </Button>
      <Dialog
        onClose={handleClose}
        aria-labelledby="dialog-title"
        open={open}
        className={classes.dialog}
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle id="dialog-title">Utwórz zlecenie</DialogTitle>
        <DialogContent>
          <div>
            <TextField
              required
              fullWidth
              select
              label="Typ"
              name="type"
              variant="outlined"
              helperText={validationErrors.type || inputErrors.typeError}
              error={validationErrors.type || inputErrors.typeError}
              onChange={handleInputChange}
              value={form.type}
              className={classes.textField}
            >
              {orderTypeOptions.map(({ value, label }) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              required
              fullWidth
              label="Opis zlecenia weryfikacji"
              name="description"
              variant="outlined"
              helperText={
                validationErrors.description || inputErrors.descriptionError
              }
              error={
                validationErrors.description || inputErrors.descriptionError
              }
              onChange={handleInputChange}
              value={form.description}
              className={classes.textField}
            />
            {generalError && (
              <Box m={1}>
                <Alert severity="error">
                  <AlertTitle>{generalError}</AlertTitle>
                </Alert>
              </Box>
            )}
          </div>
        </DialogContent>
        <DialogActions>
          {loading ? (
            <div>
              <CircularProgress className={classes.loader} />
            </div>
          ) : (
            <>
              <Button varian="outlined" disableElevation onClick={handleClose}>
                Anuluj
              </Button>
              <Button
                color="primary"
                onClick={handleSubmit}
                className={classes.buttonLogin}
                variant="contained"
                disabled={false}
                disableElevation
              >
                Utwórz
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(OrderCreate);
